export const PageBreak = () => <div type="pageBreak" />;
